import { transformToFE } from './maintenance-model';
import { axiosAuthed as axios } from '../axios-config';

export const getMaintenances = (startTime: number, endTime: number) =>
  axios
    .get(
      `/integration/timeline/maintenance-events?startTime=${startTime}&endTime=${endTime}`
    )
    .then(resp => resp.data.map(transformToFE))
    .catch(e => {
      throw e;
    });
